import React from "react";

import { FormField } from "@performyard/py-components";

import SelectGroup, { type Group } from "../../../../../../components/Inputs/SelectGroup";

export const GroupField = () => (
	<FormField<Group | null>
		id="group"
		label="Cycle Group"
		input={(field) => (
			<SelectGroup
				value={field.value ?? undefined}
				onChange={(value) => field.onChange(value)}
				placeholder="Select a group"
				isClearable
			/>
		)}
	/>
);
